<template>
	<div class="bodily">
		<h3 class="qjc-fts-16 qjc-ftw-500 qjc-c-dark">客户的体型信息</h3>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			ref="bodily"
		>
			<el-form-item
				label="身高:"
				label-width="0.42rem"
				prop="height"
			>
				<el-input
					v-model="formData.height"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="体重:"
				label-width="0.42rem"
				prop="weight"
			>
				<el-input
					v-model="formData.weight"
				></el-input>
				kg
			</el-form-item>
			
			<el-form-item
				label="胸围:"
				label-width="0.56rem"
				prop="bust"
			>
				<el-input
					v-model="formData.bust"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="腰围:"
				label-width="0.42rem"
				prop="waist"
			>
				<el-input
					v-model="formData.waist"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="臀围:"
				label-width="0.42rem"
				prop="hip"
			>
				<el-input
					v-model="formData.hip"
				></el-input>
				cm
			</el-form-item>
			
			<el-form-item
				label="体脂率:"
				label-width="0.56rem"
				prop="fat"
			>
				<el-input
					v-model="formData.fat"
				></el-input>
				%
			</el-form-item>
			
			<el-form-item class="qjc-wid-100 qjc-texta-c">
				<el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button>
			</el-form-item>
			
		</el-form>
		
	</div>
</template>

<script>
	export default{
		name: "insertBodily",
		data() {
			var heightVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 130 || value > 200){
					callback(new Error('身高为130~200'));
				}else{
					callback();
				}
			}
			var weightVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 30 || value > 160){
					callback(new Error('体重为30~160'));
				}else{
					callback();
				}
			}
			var bustVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 40 || value > 150){
					callback(new Error('胸围为40~150'));
				}else{
					callback();
				}
			}
			var waistVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 40 || value > 150){
					callback(new Error('腰围为40~150'));
				}else{
					callback();
				}
			}
			var hipVerify = (rule, value, callback) => {
				if(isNaN(value) || value < 60 || value > 165){
					callback(new Error('臀围为60~165'));
				}else{
					callback();
				}
			}
			var fatVerify = (rule, value, callback) => {
				if(isNaN(value) || value && value < 3 || value > 75){
					callback(new Error('体脂率为3~75'));
				}else{
					callback();
				}
			}
			
			return {
				rules: {
					height: [
						{ required: true, message: '请填写您的身高', trigger: 'blur' },
						{ validator: heightVerify, trigger: 'blur' }
					],
					weight: [
						{ required: true, message: '请填写您的体重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					bust: [
						{ required: true, message: '请填写您的胸围', trigger: 'blur' },
						{ validator: bustVerify, trigger: 'blur' }
					],
					waist: [
						{ required: true, message: '请填写您的腰围', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					hip: [
						{ required: true, message: '请填写您的臀围', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					fat: [
						// { required: true, message: '请填写您的体脂率', trigger: 'blur' },
						{ validator: fatVerify, trigger: 'blur' }
					]
				},
				
			}
		},
		props: ['formData'],
		methods: {
			//下一步
			next() {
				this.$refs.bodily.validate((isSuc, err) => {
					if(isSuc){
						this.$emit('checkInsertTab', 'InsertBiochemical');
					}
				});
			},
		}
	}
</script>

<style scoped>
	.bodily >>> .el-form-item__label{
		font-size: 0.14rem;
		color: #777F8F;
		padding-right: 0;
		text-align: left;
	}
	.bodily >>> .el-input{
		width: 1.6rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.bodily >>> .el-input input{
		width: 1.6rem;
		height: 0.32rem;
		font-size: 0.14rem;
		line-height: 0.14rem;
		padding: 0.09rem 0.12rem;
	}
	.bodily >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		display: none;
	}
	.bodily >>> .el-form-item__content{
		font-size: 0.14rem;
	}
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 0.32rem;
		
		.el-form-item{
			margin: 0.24rem 0.8rem 0 0;
			min-width: 2.27rem;
			
			.next{
				width: 2rem;
				height: 0.48rem;
				margin-top: 0.24rem;
			}
		}
	}
</style>
